"use client";

import { useEffect, useState } from "react";

import { clearRecentTelemetryEvents, getRecentTelemetryEvents } from "@/lib/analytics";

function fmtTime(iso) {
  try {
    return new Date(iso).toLocaleTimeString("en-ZA", { hour12: false });
  } catch {
    return iso || "";
  }
}

export function ConversionDebugPanel() {
  const [open, setOpen] = useState(false);
  const [events, setEvents] = useState([]);

  useEffect(() => {
    if (!open) return;
    const read = () => setEvents(getRecentTelemetryEvents());
    read();
    const id = window.setInterval(read, 1000);
    return () => window.clearInterval(id);
  }, [open]);

  if (process.env.NODE_ENV !== "development") return null;

  return (
    <div
      className="ed-card-glass"
      style={{
        borderRadius: 12,
        border: "1px dashed rgba(14,165,233,0.45)",
        background: "rgba(240,249,255,0.9)",
        padding: "0.6rem 0.7rem",
        marginBottom: "0.7rem",
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between", gap: "0.5rem", alignItems: "center" }}>
        <strong style={{ fontSize: "0.78rem", color: "#0c4a6e" }}>Conversion telemetry (dev only)</strong>
        <div style={{ display: "flex", gap: "0.35rem" }}>
          <button
            type="button"
            className="ed-btn-ghost"
            style={{ fontSize: "0.68rem", padding: "0.3rem 0.5rem" }}
            onClick={() => setOpen((v) => !v)}
          >
            {open ? "Hide" : "Show"}
          </button>
          <button
            type="button"
            className="ed-btn-ghost"
            style={{ fontSize: "0.68rem", padding: "0.3rem 0.5rem" }}
            onClick={() => {
              clearRecentTelemetryEvents();
              setEvents([]);
            }}
          >
            Clear
          </button>
        </div>
      </div>
      {open ? (
        <div style={{ marginTop: "0.5rem", display: "grid", gap: "0.4rem" }}>
          {events.length === 0 ? (
            <div style={{ color: "#64748b", fontSize: "0.72rem" }}>No telemetry events in this session yet.</div>
          ) : (
            events.map((event, idx) => (
              <div
                key={`${event.name}-${event.at}-${idx}`}
                style={{
                  border: "1px solid rgba(148,163,184,0.25)",
                  borderRadius: 8,
                  background: "rgba(255,255,255,0.9)",
                  padding: "0.42rem 0.52rem",
                  fontSize: "0.7rem",
                  color: "#334155",
                }}
              >
                <div style={{ display: "flex", justifyContent: "space-between", gap: "0.45rem" }}>
                  <strong style={{ color: "#0f172a" }}>{event.name}</strong>
                  <span style={{ color: "#64748b" }}>{fmtTime(event.at)}</span>
                </div>
                <div style={{ marginTop: "0.18rem", color: "#475569", overflowWrap: "anywhere" }}>
                  {Object.entries(event.params || {})
                    .map(([k, v]) => `${k}=${v}`)
                    .join(" · ")}
                </div>
              </div>
            ))
          )}
        </div>
      ) : null}
    </div>
  );
}
